import React, { FC, useEffect, useState } from 'react'
import { URLS } from '../../../constants/environment.constants'
import { ComponentCustomNav } from '../../../models/components/customNav'
import Button from '../button'
import GlobalContainer from '../globalContainer'
import { CustomHeaderContainer } from './style'
import { HomeLink, LandingPageLink, NavIcon, NavLinksMenu, NavLogo } from './subcomponents'

type Props = {
  headerData: ComponentCustomNav
}

const CustomNav: FC<Props> = ({ headerData }) => {
  if (!headerData) return null
  const [openMenu, setOpenMenu] = useState<boolean>(false)
  const { logo, logoLink, ctaLink, navLinks, landingPageLink, homeLink } = headerData
  const internalCta = ctaLink?.internalLink || {}
  const internalLogo = logoLink?.internalLink || {}
  const externalCta =
    logoLink && typeof logoLink === 'object' && 'externalUrl' in logoLink
      ? logoLink.externalUrl
      : undefined
  const imgURL = logo?.image?.file?.url
  const logoLinkSlugUrl = 'slug' in internalLogo ? URLS.PROD + internalLogo.slug : ''
  const imgSrc =
    typeof logoLinkSlugUrl === 'string' && logoLinkSlugUrl
      ? logoLinkSlugUrl
      : typeof externalCta === 'string'
      ? externalCta
      : '#'

  const isObject = (item: any) => item !== null && typeof item === 'object'

  const ctaText = isObject(ctaLink) && 'ctaText' in ctaLink ? ctaLink?.ctaText : ''
  const text = isObject(ctaLink) && 'text' in ctaLink ? ctaLink?.text : ''
  const buttonTxt = ctaText || text || ''

  const ctaLinkSlugUrl =
    isObject(internalCta) && 'slug' in internalCta ? URLS.PROD + internalCta.slug : ''
  const buttonUrl =
    isObject(ctaLink) && 'externalUrl' in ctaLink ? ctaLink.externalUrl : ctaLinkSlugUrl || '#'

  const handleResize = () => {
    //* 1024 represents sm screen width
    if (window.innerWidth > 1024) setOpenMenu(false)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const navLogo = <NavLogo imgSrc={imgSrc} altText={logo?.altText || ''} imgUrl={imgURL || ''} />

  const button = (
    <Button
      icon
      type={'primary'}
      theme={'light'}
      className="CustomHeader__Button"
      href={buttonUrl}
      text={buttonTxt}
      size="small"
    />
  )

  const navLinksData = <NavLinksMenu navLinks={navLinks} openMenu={openMenu} />

  return (
    <CustomHeaderContainer $openMenu={openMenu} data-cy="customNav">
      <GlobalContainer className="CustomHeader__Wrapper">
        <div className="CustomHeader__Left">
          {logo && navLogo}
          {landingPageLink && <LandingPageLink landingPageLink={landingPageLink} />}
          {navLinks && navLinksData}
        </div>
        <div className="CustomHeader__Right">
          {logo && navLogo}
          {navLinks && navLinksData}
          {homeLink && <HomeLink homeLink={homeLink} />}
          {ctaLink && button}
        </div>

        {<NavIcon openMenu={openMenu} setOpenMenu={setOpenMenu} />}
      </GlobalContainer>
    </CustomHeaderContainer>
  )
}

export default CustomNav
